import {Component, OnInit} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../../services/alert.service";
import {AuthService} from "../../services/auth.service";

@Component({
  selector: 'micro-voiceLog-detail',
  templateUrl: './voiceLog-detail.component.html'
})
export class VoiceLogDetailComponent implements OnInit {
  voiceLog:any;
  voiceLogResult:any;

  constructor(private env: EnvService,
              private http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              public authService:AuthService,
              private alertService:AlertService) {
  }

  public ngOnInit(): void {
    this.route.params
      .subscribe((params: Params) => {
        let id:any = params['id'];
        this.http.get(`${this.env.e.url}/voice/voiceLogs/${id}`).subscribe(
          data => {
            this.setVoiceLog(data)
          }
        );
      });
  }

  setVoiceLog(voiceLog:any) {
    this.voiceLog = voiceLog;
    this.voiceLogResult = JSON.parse(voiceLog.result);
  }
}
